export default "__VITE_ASSET__DSskNzN2__"